import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const token = localStorage.getItem('token');

    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    // Solo agrega Authorization si el token es válido
     if (token && token !== 'null') {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const clonedRequest = request.clone({
      setHeaders: headers
    });

    return next.handle(clonedRequest);
  }
}